{
 "_meta": {
  "locale": "he",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "עכשיו",
  "people": "אנשים",
  "cases": "תיקים",
  "agenda": "יומן",
  "reviews": "סקירות",
  "prospects": "איתור לקוחות",
  "insights": "תובנות",
  "data": "נתונים ואבטחה",
  "settings": "הגדרות",
  "lens": "עדשה"
 },
 "common": {
  "save": "שמירה",
  "cancel": "ביטול",
  "close": "סגירה",
  "search": "חיפוש",
  "today": "היום",
  "tomorrow": "מחר",
  "new": "חדש",
  "edit": "עריכה",
  "delete": "מחיקה"
 },
 "settings": {
  "title": "הגדרות",
  "language": "שפה",
  "region": "שוק / אזור",
  "theme": "מראה"
 },
 "people": {
  "title": "אנשים",
  "new": "איש קשר חדש"
 },
 "today": {
  "agenda_title": "היום"
 },
 "lens": {
  "placeholder": "חפשו אנשים, לקוחות פוטנציאליים, תיקים — או הקלידו פקודה"
 }
}